import { createSelector } from 'reselect';
import { initialState } from './reducer';

const selectFilters = state => state.get('catalogFilter', initialState);

const makeSelectTags = () =>
  createSelector(selectFilters, selectedState =>
    selectedState.get('tags').toArray(),
  );

const makeSelectFiltersOption = () =>
  createSelector(selectFilters, selectedState =>
    selectedState.get('selectedTags').toArray(),
  );

const makeSelectSelectedTags = () =>
  createSelector(selectFilters, selectedState =>
    selectedState.get('selectedTags').toArray(),
  );

const makeSelectSort = () =>
  createSelector(selectFilters, selectedState =>
    selectedState.get('sorts').toArray(),
  );

const makeSelectSelectedSort = () =>
  createSelector(selectFilters, selectedState =>
    selectedState.get('selectedSort'),
  );

export {
  selectFilters,
  makeSelectTags,
  makeSelectSelectedTags,
  makeSelectFiltersOption,
  makeSelectSort,
  makeSelectSelectedSort,
};
